module.exports = __webpack_public_path__ + "img/logo-kkp2.f6b93ed7.png";